import {store} from "@/store";

/**
 * DEV-3011 — AI rapor sohbetlerinin GEÇİCİ deposu.
 *
 * Sohbet, ürünün kendisi değil ürüne (kayıtlı rapora) giden yoldur; bu yüzden
 * tarayıcıda tutulur, sunucuya yazılmaz. Prompt metinleri borçlu adı/TCKN gibi
 * kişisel veri içerebildiğinden sunucuda serbest metin biriktirmek ayrı bir
 * saklama/silme kararı gerektirir — o karar verilene kadar veri cihazda kalır.
 *
 * Sonuç SATIRLARI saklanmaz: hem yer kaplar hem bayatlar; sohbete dönüldüğünde
 * rapor taslaktan yeniden çalıştırılır.
 *
 * Vue 3 tasarım turunda arayüz değişse de bu modülün sözleşmesi (oku/yaz/sil/temizle)
 * korunur; depo veritabanına taşınırsa yalnız bu dosya değişir.
 */

export interface GecmisMesaji {
    rol: "kullanici" | "ai";
    metin?: string;
    yerineGecen?: boolean;
    taslak?: any;
}

export interface GecmisSohbeti {
    id: string;
    baslik: string;
    olusturma: number;
    guncelleme: number;
    mesajlar: Array<GecmisMesaji>;
    sonTaslak: any;
    kayitliRaporAdi?: string;
    /** Sohbet bir rapora dönüştüyse o raporun id'si — geçmişten rapora atlamak için */
    kayitliRaporId?: number;
}

const SURUM = 1;
const SOHBET_SINIRI = 20;
const GUN_SINIRI = 30;
const BASLIK_UZUNLUGU = 48;

/** Anahtar kiracı+kullanıcı bazlıdır: aynı tarayıcıyı paylaşan iki kullanıcı birbirinin
 *  isteklerini görmemeli (büroda aynı bilgisayar yaygın). */
function anahtar(): string {
    const kiracı = store.state.tenant_id || "yok";
    const kullanici = (store.state.user && (store.state.user as any).id) || "yok";
    return `rapor-ai-sohbetler:${kiracı}:${kullanici}`;
}

function eskileriEle(sohbetler: Array<GecmisSohbeti>): Array<GecmisSohbeti> {
    const sinir = Date.now() - GUN_SINIRI * 24 * 60 * 60 * 1000;
    return sohbetler
        .filter(s => s.guncelleme >= sinir)
        .sort((a, b) => b.guncelleme - a.guncelleme)
        .slice(0, SOHBET_SINIRI);
}

export function gecmisiOku(): Array<GecmisSohbeti> {
    try {
        const ham = window.localStorage.getItem(anahtar());
        if (!ham) return [];
        const paket = JSON.parse(ham);
        if (!paket || paket.surum !== SURUM || !Array.isArray(paket.sohbetler)) return [];
        return eskileriEle(paket.sohbetler);
    } catch (e) {
        return []; // bozuk/kapalı depolama akışı durdurmaz
    }
}

function gecmisiYaz(sohbetler: Array<GecmisSohbeti>): Array<GecmisSohbeti> {
    const liste = eskileriEle(sohbetler);
    try {
        window.localStorage.setItem(anahtar(), JSON.stringify({surum: SURUM, sohbetler: liste}));
    } catch (e) {
        // Kota dolduysa en eskiyi atıp bir kez daha dene; yine olmazsa sessizce vazgeç
        try {
            const kisa = liste.slice(0, Math.max(1, Math.floor(liste.length / 2)));
            window.localStorage.setItem(anahtar(), JSON.stringify({surum: SURUM, sohbetler: kisa}));
            return kisa;
        } catch (e2) {
            // yoksay
        }
    }
    return liste;
}

export function baslikUret(ilkMesaj: string): string {
    const temiz = (ilkMesaj || "").trim().replace(/\s+/g, " ");
    if (temiz.length <= BASLIK_UZUNLUGU) return temiz || "Adsız sohbet";
    return temiz.slice(0, BASLIK_UZUNLUGU - 1) + "…";
}

/** Var olan sohbeti günceller, yoksa ekler. Dönen liste ekranda gösterilecek hâlidir. */
export function sohbetiKaydet(sohbet: GecmisSohbeti): Array<GecmisSohbeti> {
    const liste = gecmisiOku().filter(s => s.id !== sohbet.id);
    liste.unshift(sohbet);
    return gecmisiYaz(liste);
}

export function sohbetiSil(id: string): Array<GecmisSohbeti> {
    return gecmisiYaz(gecmisiOku().filter(s => s.id !== id));
}

export function gecmisiTemizle(): Array<GecmisSohbeti> {
    try {
        window.localStorage.removeItem(anahtar());
    } catch (e) {
        // yoksay
    }
    return [];
}

export function yeniSohbetKimligi(): string {
    return String(Date.now()) + "-" + Math.random().toString(36).slice(2, 8);
}
